import { render } from "./Initialize-View.vue?vue&type=template&id=3704edb0"
import script from "./Initialize-View.vue?vue&type=script&lang=js"
export * from "./Initialize-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__